//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

 
export default {
    components: {
       
    },
    watch: {},
    methods: {
        showPlateSelector() {
            this.$bus.emit("showPlateSelector", null);
        },
        init() {
            let that = this;
            /*
            var url =
              "/api/v1/get_wx_config/" +
              encodeURIComponent(location.href.split("#")[0]);
      
            that.$http.post(url).then((ret) => {
              console.log(ret);
              that.$wechat.config(ret.data);
            });
          */

            //获取cookies，然后，如果拿到的数据是空，重新请求一次wx的openid
            var wx_id = that.$cookies.get("wx_id");
            if (
                wx_id == undefined ||
                wx_id == null ||
                wx_id == "" ||
                wx_id == "null" ||
                wx_id == "undefined"
            ) {
                var code = that.getQueryValue("code");
                var code_url = "/api/v1/get_page_token/" + code;
                that.$http.post(code_url).then((ret) => {
                    console.log(JSON.stringify(ret.data));
                    that.wx_id = ret.data.openId;
                    that.$cookies.set("wx_id", that.wx_id);
                });
            }
        },
        getQueryValue(queryName) {
            let that = this;
            var query = decodeURIComponent(window.location.href.split("?")[1]);
            var vars = query.split("&");
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == queryName) {
                    return pair[1];
                }
            }
            return null;
        },
        check_id() {
            let that = this;
            let Base64 = require("js-base64").Base64;
            var url =
                "/api/v1/check_id/" +
                Base64.encode(
                    that.$cookies.get("wx_id") + "," + that.phone + "," + that.plate_no
                );

            that.$http.post(url).then((ret) => {
                console.log(JSON.stringify(ret));
                if (ret.data.code == 0) {
                    that.$vux.alert.show({
                        title: "绑定成功",
                        content: ret.data.message,
                        onShow() { },
                        onHide() {

                            that.$router.push("/ScanQR")

                        },
                    });
                    //that.$wechat.config(ret.data);
                } else {
                    that.$vux.alert.show({
                        title: "绑定失败",
                        content: ret.data.message,
                        onShow() { },
                        onHide() { },
                    });
                }
            });
        },
    },
    mounted() {

        //获取数据
        let that = this
         
        that.$http.get("/api/v1/get_bind_data/all").then(res=>{
           
            that.tableData = res.data.data;

        }).catch(function (error) {
         
            console.log(error);
        });;



     },
    data() {
        return {
            tableData:[],
            wx_id: "",
            phone: "",
            plate_no: "",
            carNum: "",
        };
    },
};



// WEBPACK FOOTER //
// ./src/components/BindList.vue